import type { ManualPaymentMethod, ManualPaymentMethodConfig } from "@/types";

export const MANUAL_PAYMENT_NUMBER_NEO = "79371541";

export const MANUAL_PAYMENT_NUMBER_WHISH = "79371541";

export const MANUAL_PAYMENT_METHOD_ORDER: ManualPaymentMethod[] = ["whish", "neo"];

export const MANUAL_PAYMENT_METHODS: Record<ManualPaymentMethod, ManualPaymentMethodConfig> = {
  whish: {
    title: "Pay by WHISH",
    buttonLabel: "Pay by WHISH",
    label: "WHISH",
    color: "error",
    logoSrc: "/whish-logo.svg",
    logoModalSrc: "/whish-logo-contrast.webp",
    logoAlt: "WHISH",
    buttonLogoWidth: 34,
    buttonLogoHeight: 34,
    modalLogoWidth: 120,
    modalLogoHeight: 40,
    instructionsContent: [
      "1. Open the Whish app.",
      "2. Tap **Transfer**.",
      "3. Select **Whish To Whish**.",
      `4. Enter the number: **${MANUAL_PAYMENT_NUMBER_WHISH}**.`,
      "5. Enter the exact amount shown.",
      "6. Add your reference in the note: **the payment reference shown above**.",
      "7. Tap **Send**",
      `8. Once done click the "**I've sent the payment**" button`,
    ].join("\n"),
  },
  neo: {
    title: "Pay by NEO",
    buttonLabel: "Pay by NEO",
    label: "NEO",
    color: "success",
    logoSrc: "/neo-logo.webp",
    logoModalSrc: "/neo-logo-contrast.webp",
    logoAlt: "NEO",
    buttonLogoWidth: 50,
    buttonLogoHeight: 18,
    modalLogoWidth: 120,
    modalLogoHeight: 40,
    instructionsContent: [
      "1. Open your neo app.",
      "2. Choose **Transfers**.",
      "3. Select the desired account.",
      "4. Select **Via Mobile Number or IBAN**.",
      "5. Tap **New Mobile No**.",
      `6. Enter the number: **${MANUAL_PAYMENT_NUMBER_NEO}**.`,
      "7. Enter the exact amount shown.",
      "8. Add your reference in the Description: **the payment reference shown above**.",
      "9. Confirm the payment.",
      `10. Once done click the "**I've sent the payment**" button`,
    ].join("\n"),
  },
};

export const MANUAL_PAYMENT_DIALOG_COPY = {
  referenceLabel: "Payment reference",
  amountLabel: "Amount to send",
  expiryLabel: "Booking hold",
  expiryPrefix: "Session expires in",
  expiryExpiredLabel: "Session expired",
  expiryDescription:
    "Please complete the transfer and tap the confirmation button before this timer runs out.",
  expiryExpiredDescription:
    "This booking hold has ended, so the slot may already have been released.",
  copyReferenceLabel: "Copy",
  copiedReferenceLabel: "Copied",
  copyReferenceAriaLabel: "Copy payment reference",
  howToPayTitle: "How to pay",
  nextStepsTitle: "What happens next",
  confirmButtonLabel: "I've sent the payment",
  confirmingButtonLabel: "Saving payment details...",
  expiredButtonLabel: "Session expired",
  confirmButtonHint:
    "Click this only after you have completed the transfer so we can start reviewing your payment.",
  nextStepsContent: [
    "1. You send the payment.",
    "2. Once the money reaches our account, we will approve your session.",
    "3. Once approved you will receive a confirmation/receipt email.",
  ].join("\n"),
  importantTitle: "Important",
  importantContent: [
    "- Your session will expire in 15 minutes, and the booking slot will be released.",
    "- If payment is made after the session has expired and the slot has been released, you will either receive a refund or be asked to choose another slot.",
    "- Make sure you enter the correct reference so we can match your payment.",
    "- Payments without a reference may delay confirmation.",
  ].join("\n"),
} as const;
